import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {MacroInputCommonProps} from './common/macroInputTypes';
import {MacroInputDropdown} from './macroInputDropdown';

/*
 * Props.
 */

interface MacroInputBooleanProps extends MacroInputCommonProps<boolean> {}

/*
 * Constants.
 */

const dropdownItems = [
  {
    label: <Trans id="macro-input-boolean-yes">Yes</Trans>,
    value: true,
  },
  {
    label: <Trans id="macro-input-boolean-no">No</Trans>,
    value: false,
  },
];

/*
 * Component.
 */

export const MacroInputBoolean: FC<MacroInputBooleanProps> = ({value, onChange, description, label}) => (
  <MacroInputDropdown<boolean>
    value={value}
    renderValue={(val) => dropdownItems.find((item) => item.value === val)?.label}
    dropdownItems={dropdownItems}
    label={label}
    onChange={onChange}
    description={description}
    placeholderIcon="togglesSmall"
  />
);
